import { FormikProps } from "formik";
import ATMLoadingButton from "src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton";
import ATMCheckbox from "src/components/UI/atoms/formFields/ATMCheckbox/ATMCheckbox";
import ATMMultiSelect from "src/components/UI/atoms/formFields/ATMMultiSelect/ATMMultiSelect";
import ATMTextArea from "src/components/UI/atoms/formFields/ATMTextArea/ATMTextArea";
import ATMTextField from "src/components/UI/atoms/formFields/ATMTextField/ATMTextField";
import useBranches from "src/hooks/useGetBranches";
import { AccountFormValues } from "src/models/Account.model";

type Props = {
  formikProps: FormikProps<AccountFormValues>;
  onClose: () => void;
  formType: "Add" | "Edit";
};

const AccountForm = ({ formikProps, onClose, formType }: Props) => {
  const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;
  const { branches, isDataLoading: isBranchLoading } = useBranches();

  return (
    <div className="p-4 flex flex-col gap-6">
      <div className="flex justify-between items-center">
        <div className="text-xl font-medium"> {formType} Account </div>
        <button type="button" className="hover:bg-hover" onClick={onClose}>
          Cancel
        </button>
      </div>
      <div className="flex flex-col gap-4">
        {/* Account Name */}
        <div className="">
          <ATMTextField
            name="accountName"
            value={values.accountName}
            onChange={(e) => setFieldValue("accountName", e.target.value)}
            label="Account Name"
            placeholder="Enter Account Name"
            onBlur={handleBlur}
          />
        </div>

        {/* Opening Balance */}
        <div className="">
          <ATMTextField
            name="openingBalance"
            value={values.openingBalance}
            onChange={(e) => setFieldValue("openingBalance", e.target.value)}
            label="Opening Balance"
            placeholder="Enter Opening Balance"
            onBlur={handleBlur}
          />
        </div>

        {/* For All Branches */}
        <div className="mt-1">
          <ATMCheckbox
            checked={values.forAllBranches}
            disabled={isBranchLoading}
            onChange={(newValue) => {
              setFieldValue("forAllBranches", newValue);
            }}
            label="For All Branch"
          ></ATMCheckbox>
        </div>

        {/* Branches  */}
        <div className={`${values.forAllBranches && "hidden"}`}>
          <ATMMultiSelect
            name="branches"
            value={values.branches}
            onChange={(newValue) => setFieldValue("branches", newValue)}
            onBlur={handleBlur}
            label="Branches"
            placeholder="Select Branch"
            isLoading={isBranchLoading}
            options={branches?.map((branch: any) => ({
              label: branch?.branchName,
              value: branch?._id,
            }))}
          />
        </div>

        {/* Account Details */}
        <div className="">
          <ATMTextArea
            name="accountDetails"
            value={values.accountDetails}
            onChange={(value) => setFieldValue("accountDetails", value)}
            label="Account Details"
            placeholder="Enter Account Details"
            onBlur={handleBlur}
          />
        </div>
      </div>
      <div>
        <ATMLoadingButton isLoading={isSubmitting} type="submit">
          Save
        </ATMLoadingButton>
      </div>
    </div>
  );
};

export default AccountForm;
